import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import {getLocalStorageUserState} from 'commons/localStorage.utilities';

type ClientBuilder = (url: string) => ApolloClient<NormalizedCacheObject>;

export const client: ClientBuilder = url => {
  const uploadLink = createUploadLink({
    uri: url,
    headers: {'Apollo-Require-Preflight': 'true'},
    // Include cookies in cross-origin requests so the gateway can forward the
    // session cookie to subgraphs and maintain server-side session state.
    credentials: 'include',
  });

  // Inject the authenticated user's ID on every request so subgraphs can
  // populate audit fields (created_by, updated_by) without relying on
  // server-side session propagation across the gateway boundary.
  const userIdLink = setContext((_, {headers}) => {
    const stored = getLocalStorageUserState('userDetails');
    const userId: string = stored?.data?.id ?? '';
    return {
      headers: {
        ...headers,
        ...(userId ? {'x-user-id': userId} : {}),
      },
    };
  });

  return new ApolloClient({
    link: ApolloLink.from([userIdLink, uploadLink as unknown as ApolloLink]),
    cache: new InMemoryCache(),
  });
};
